import styled from "styled-components";

export const Icon = styled.img.attrs({
  alt: "",
  "aria-hidden": true
})``;
